import call from './call';
import {GET_ROLES} from "../types";

export default (form) => async (dispatch) =>
{
    const onResult= (result) =>
    {
        if(result && result[1].success)
            dispatch({type: GET_ROLES, payload: {roles: result[1].results, total:result[1].total}});
    };
    dispatch(call("SystemService/getAllRoles",form,onResult));
};